import { css } from "lit";

export const wizardStyles = css`
  :host {
    display: block;
    width: 100%;
    height: 100dvh;
    overflow-y: auto;
  }

  .wizard-container {
    display: flex;
    flex-direction: column;
    gap: var(--sds-spacing-l);
  }

  .step-content {
    position: relative;
    min-height: 100px;
  }

  .step-content ::slotted(*) {
    width: 100%;
    max-height: 0;
    opacity: 0;
    visibility: hidden;
    transition:
      opacity 0.3s ease,
      visibility 0.3s ease;
  }

  .step-content ::slotted(.active) {
    opacity: 1;
    visibility: visible;
    max-height: unset;
  }
`;
